import React from 'react';
import { useLocation } from 'react-router-dom';
import { NavButton } from './NavButton';
const NAV_ITEMS = [{
  label: 'about',
  path: '/'
}, {
  label: 'dinners',
  path: '/dinners'
}, {
  label: 'journals',
  path: '/journals'
}];
export function NavigationSidebar() {
  const location = useLocation();
  return <div className="fixed left-4 top-0 bottom-0 w-52 z-20 flex pointer-events-none md:pointer-events-auto" data-id="element-176">
      {/* Navigation area */}
      <div className="flex-1 flex flex-col justify-center relative pointer-events-auto" data-id="element-177">
        {/* Connecting lines to buttons */}
        <svg className="absolute left-0 top-0 w-full h-full pointer-events-none" style={{
        zIndex: 0
      }} data-id="element-178">
          {NAV_ITEMS.map((_, i) => {
          const yPos = 35 + i * 15;
          return <line key={i} x1="0" y1={`${yPos}%`} x2="30" y2={`${yPos}%`} stroke="#E5D68A" strokeWidth="3" data-id="element-179" />;
        })}
        </svg>

        {/* Navigation Buttons */}
        <nav className="flex flex-col space-y-5 relative z-10" data-id="element-180">
          {NAV_ITEMS.map((item, index) => <NavButton key={item.label} label={item.label} to={item.path} index={index} isActive={location.pathname === item.path && (item.path !== '/' || location.pathname === '/')} data-id="element-181" />)}
        </nav>
      </div>
    </div>;
}